const it = {
  common: {
    facts: "In cifre",
    why: "Perché scegliere l'Hotel Ciutat Martorell",
    related: "Potrebbe interessarti anche",
    quoteEyebrow: "Raccontaci il vostro matrimonio",
  },
  nearSeat: {
    seoTitle: "Hotel vicino a SEAT-CUPRA Martorell · a 5 min dalla fabbrica",
    seoDesc: "Hotel 4★ a 5 minuti dalla fabbrica SEAT-CUPRA e dalle zone industriali di Martorell. Tariffe aziendali, WiFi in fibra, parcheggio, ristorante e treno a 100 m.",
    eyebrow: "Hotel per le visite a SEAT-CUPRA",
    title: ["Il tuo hotel a 5 minuti", "da SEAT-CUPRA Martorell"],
    intro: "Fornitori, ingegneri, formatori e team di progetto soggiornano da noi perché la fabbrica e le zone industriali di Martorell sono a due passi, e il treno per Barcellona a 100 metri.",
    facts: [
      { k: "Fabbrica SEAT-CUPRA", v: "5 min in auto" },
      { k: "Renfe e FGC", v: "100 m" },
      { k: "Barcellona", v: "30 min" },
      { k: "Aeroporto El Prat", v: "25 min" },
    ],
    sections: [
      { h: "Pensato per il soggiorno di lavoro", p: "Camere di 21 m² con scrivania, WiFi in fibra gratuito e climatizzazione. Colazione a buffet dalle 06:30 alle 10:30 per arrivare puntuali al turno del mattino, reception 24 h per gli arrivi tardivi e Business Corner per stampare o chiudere un report." },
      { h: "Tariffe aziendali e fatturazione centralizzata", p: "Per le aziende che visitano regolarmente lo stabilimento offriamo tariffe negoziate, fatturazione centralizzata e gestione rapida delle prenotazioni di gruppo. Indicaci il volume approssimativo di notti e prepariamo una proposta." },
      { h: "Riunioni e formazione accanto alla fabbrica", p: "Tre sale con luce naturale da 35 a 220 m² per formazione fornitori, kick-off o audit, con proiettore, fibra e coffee break. E il ristorante My Bar per i pranzi di lavoro, con menu executive dal lunedì al venerdì." },
    ],
    why: [
      "A 5 minuti in auto dalla fabbrica SEAT-CUPRA e dalle zone industriali di Martorell",
      "Parcheggio privato nell'hotel (con supplemento)",
      "WiFi in fibra gratuito e scrivania in tutte le camere",
      "Colazione dalle 06:30 e reception 24 ore",
      "Tariffe aziendali con fatturazione centralizzata",
    ],
    faqTitle: "Soggiornare vicino a SEAT-CUPRA",
    cta: { title: "Prenotazione diretta o tariffa aziendale", text: "Prenota sul sito ufficiale al miglior prezzo garantito o richiedi una tariffa aziendale per il tuo team.", secondary: "Tariffe per aziende", secondaryTo: "corporate" },
    related: [
      { to: "corporate", label: "Hotel per aziende" },
      { to: "meetingRooms", label: "Sale riunioni" },
      { to: "blogPost", params: { slug: "donde-alojarse-si-visitas-martorell-por-trabajo" }, label: "Dove alloggiare se visiti Martorell per lavoro" },
    ],
  },
  nearMontserrat: {
    seoTitle: "Hotel vicino a Montserrat · a 20 min dal monastero",
    seoDesc: "Hotel 4★ a Martorell a 20 minuti in auto da Montserrat e con treno FGC a 100 m verso la cremagliera. Base comoda per visitare il monastero e Barcellona.",
    eyebrow: "Hotel per visitare Montserrat",
    title: ["Montserrat a 20 minuti,", "Barcellona a 30"],
    intro: "Martorell è il punto intermedio perfetto: al mattino il monastero e le montagne di Montserrat, al pomeriggio Barcellona. E la sera, una camera tranquilla con ristorante e parcheggio.",
    facts: [
      { k: "Monastero di Montserrat", v: "20 min in auto" },
      { k: "Treno FGC per la cremagliera", v: "a 100 m dall'hotel" },
      { k: "Barcellona", v: "30 min" },
      { k: "Aeroporto El Prat", v: "25 min" },
    ],
    sections: [
      { h: "Come arrivare a Montserrat dall'hotel", p: "In auto, 20 minuti fino al monastero o al parcheggio della cremagliera a Monistrol. Con i mezzi pubblici, la stazione FGC è a 100 metri: linea R5 fino a Monistrol de Montserrat e salita in cremagliera, oppure fino a Montserrat-Aeri e salita in funivia." },
      { h: "Un giorno in montagna, una notte di riposo", p: "Dopo la basilica, l'Escolania o un'escursione fino a Sant Jeroni, torna in una camera di 21 m² con climatizzazione, bagno con doccia e WiFi in fibra. Cena al ristorante My Bar con cucina mediterranea di mercato e vini del Penedès." },
      { h: "Abbina Montserrat a Barcellona", p: "Dalle stazioni Renfe e FGC, Barcellona è a circa 30 minuti. Puoi dedicare un giorno a Montserrat e un altro alla città senza cambiare hotel né lottare per un parcheggio in centro." },
    ],
    why: [
      "A 20 minuti in auto dal monastero di Montserrat",
      "Stazione FGC a 100 metri con collegamento a cremagliera e funivia",
      "Parcheggio privato per lasciare l'auto e muoversi in treno",
      "Ristorante My Bar con cucina mediterranea e vini del Penedès",
      "Colazione a buffet dalle 06:30 alle 10:30 per partire presto in montagna",
    ],
    faqTitle: "Visitare Montserrat dall'hotel",
    cta: { title: "Prenota la tua base per Montserrat", text: "Prenotazione diretta sul sito ufficiale al miglior prezzo garantito. Venite in gruppo? Chiedeteci una proposta.", secondary: "Come arrivare all'hotel", secondaryTo: "location" },
    related: [
      { to: "blogPost", params: { slug: "como-llegar-a-montserrat-desde-martorell" }, label: "Come arrivare a Montserrat da Martorell" },
      { to: "location", label: "Posizione e come arrivare" },
      { to: "blogPost", params: { slug: "que-visitar-cerca-de-martorell" }, label: "Cosa visitare vicino a Martorell" },
    ],
  },
  parkingBarcelona: {
    seoTitle: "Hotel con parcheggio vicino a Barcellona · a 30 min in treno",
    seoDesc: "Hotel 4★ con parcheggio privato a Martorell, a 30 minuti da Barcellona. Lascia l'auto ed entra in città con Renfe o FGC dalla stazione a 100 m. Prenotazione diretta.",
    eyebrow: "Hotel con parcheggio",
    title: ["Parcheggia l'auto,", "Barcellona in 30 minuti"],
    intro: "Se arrivi in auto a Barcellona, dormire fuori dal centro è più tranquillo e semplice: parcheggio privato in hotel e treno diretto per la città a 100 metri dalla porta.",
    facts: [
      { k: "Parcheggio privato", v: "in hotel" },
      { k: "Stazioni Renfe e FGC", v: "100 m" },
      { k: "Centro di Barcellona", v: "30 min" },
      { k: "Aeroporto El Prat", v: "25 min" },
    ],
    sections: [
      { h: "Parcheggio privato nell'hotel stesso", p: "Posti auto privati per i clienti alloggiati (con supplemento), senza cercare parcheggio né pagare le tariffe dei garage del centro di Barcellona. Entri ed esci quando vuoi e l'auto resta a due passi dalla camera." },
      { h: "A Barcellona in treno, senza traffico", p: "Le stazioni Renfe (Rodalies) e FGC sono a 100 metri. In circa 30 minuti sei in centro; al ritorno, l'auto ti aspetta. Per muoverti nella provincia, la A-2 e la AP-7 sono accanto." },
      { h: "Un hotel completo per la fuga", p: "92 camere di 21 m² con WiFi in fibra, ristorante My Bar, palestra e colazione a buffet dalle 06:30 alle 10:30. Ideale per famiglie e coppie che visitano Barcellona o Montserrat in auto." },
    ],
    why: [
      "Parcheggio privato per gli ospiti in hotel",
      "Treni per Barcellona a 100 metri: Renfe e FGC",
      "A 30 minuti da Barcellona e 25 dall'aeroporto",
      "Camere Doppia e Twin da 21 m² con WiFi in fibra",
      "Ristorante, palestra e reception 24 h",
    ],
    faqTitle: "Parcheggio e come andare a Barcellona",
    cta: { title: "Prenota con parcheggio e dimentica l'auto", text: "Prenotazione diretta sul sito ufficiale al miglior prezzo garantito; facci sapere se arrivi in auto.", secondary: "Servizi dell'hotel", secondaryTo: "services" },
    related: [
      { to: "blogPost", params: { slug: "como-ir-de-martorell-a-barcelona" }, label: "Come andare da Martorell a Barcellona" },
      { to: "services", label: "Servizi dell'hotel" },
      { to: "blogPost", params: { slug: "transportes-entre-martorell-y-barcelona" }, label: "Trasporti tra Martorell e Barcellona" },
    ],
  },
  weddingsBaix: {
    seoTitle: "Hotel per matrimoni nel Baix Llobregat · Martorell",
    seoDesc: "Celebra il tuo matrimonio a Martorell: Sala Banchetti fino a 150 invitati, cocktail fino a 200 in terrazza, menu degustazione, camera nuziale e tariffe per gli invitati.",
    eyebrow: "Matrimoni nel Baix Llobregat",
    title: ["Il vostro matrimonio nel Baix Llobregat,", "tutto sotto lo stesso tetto"],
    intro: "Cocktail in terrazza, banchetto in una sala di 220 m² con luce naturale, cucina mediterranea propria e 92 camere perché nessuno debba guidare per tornare a casa. A 30 minuti da Barcellona e ben collegato a tutta la comarca.",
    facts: [
      { k: "Banchetto", v: "fino a 150 invitati" },
      { k: "Cocktail", v: "fino a 200 persone" },
      { k: "Sala Banchetti", v: "220 m² con luce naturale" },
      { k: "Camere", v: "92 per gli invitati" },
    ],
    sections: [
      { h: "Spazi: terrazza, sala e camere", p: "Il cocktail di benvenuto in terrazza, il banchetto nella Sala Banchetti modulabile di 220 m² e, alla fine, la camera nuziale in omaggio e tariffe speciali per gli invitati che si fermano a dormire." },
      { h: "Cucina propria e menu degustazione", p: "Il nostro team di cucina prepara menu di nozze su misura con prodotti mediterranei di stagione e vini del Penedès. Prima del grande giorno organizziamo una degustazione per definire ogni piatto con gli sposi." },
      { h: "Un coordinatore dal primo caffè", p: "Preventivo chiuso in 48 ore, senza sorprese. Un coordinatore dedicato gestisce tempi, fornitori, DJ e open bar opzionale perché la coppia debba solo godersi la giornata." },
    ],
    why: [
      "Ben collegato per invitati da Barcellona e da tutta la comarca: 30 min in auto e treno a 100 m",
      "Sala di 220 m² con luce naturale e terrazza per il cocktail",
      "Camera nuziale in omaggio e tariffe speciali per gli invitati",
      "Menu degustazione preventivo e cucina mediterranea propria",
      "Coordinatore dedicato e preventivo chiuso in 48 ore",
    ],
    faqTitle: "Celebrare il matrimonio in hotel",
    cta: { title: "Raccontateci come immaginate il vostro matrimonio", text: "Indicateci la data approssimativa, il numero di invitati e cosa avete in mente; vi rispondiamo con una proposta entro 48 ore." },
    related: [
      { to: "weddings", label: "Matrimoni in hotel" },
      { to: "events", label: "Eventi e celebrazioni" },
      { to: "meetingRoomDetail", params: { slug: "salon-montserrat" }, label: "Sala Banchetti" },
    ],
  },
};

export default it;
